import { render, staticRenderFns } from "./SalesDashboardV1.vue?vue&type=template&id=0219e9d3&scoped=true&"
import script from "./SalesDashboardV1.vue?vue&type=script&lang=js&"
export * from "./SalesDashboardV1.vue?vue&type=script&lang=js&"
import style0 from "./SalesDashboardV1.vue?vue&type=style&index=0&id=0219e9d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0219e9d3",
  null
  
)

export default component.exports